import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const FirePlaceIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "FirePlaceIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.1215 18.5348H21.5727V5.46527H22.1215C22.4438 5.46527 22.7052 5.20389 22.7052 4.88162C22.7052 4.55935 22.4438 4.29797 22.1215 4.29797H3.67838C3.35611 4.29797 3.09473 4.55935 3.09473 4.88162C3.09473 5.20389 3.35611 5.46527 3.67838 5.46527H4.22717V18.5348H3.67838C3.35611 18.5348 3.09473 18.7962 3.09473 19.1185C3.09473 19.4409 3.35611 19.7021 3.67838 19.7021H22.1215C22.4438 19.7021 22.7052 19.4409 22.7052 19.1185C22.7052 18.7962 22.4438 18.5348 22.1215 18.5348ZM12.1806 17.8155C12.1806 17.602 12.4842 16.9365 12.9001 16.2023C13.316 16.9365 13.6196 17.602 13.6196 17.8155C13.6196 18.2121 13.2969 18.5348 12.9001 18.5348C12.5033 18.5348 12.1806 18.2121 12.1806 17.8155ZM14.7235 17.387C14.6419 17.0797 14.4601 16.6194 14.0637 15.8947C13.7317 15.2879 13.4044 14.7792 13.3907 14.7579C13.2833 14.5911 13.0985 14.4904 12.9001 14.4904C12.7017 14.4904 12.5169 14.5911 12.4095 14.7579C12.3957 14.7792 12.0685 15.2879 11.7365 15.8947C11.3401 16.6194 11.1583 17.0797 11.0767 17.387C10.9491 17.1221 10.8776 16.8255 10.8776 16.5123C10.8776 15.7343 11.9738 13.6665 12.9002 12.1332C13.8265 13.6662 14.9226 15.7336 14.9226 16.5123C14.9226 16.8255 14.8511 17.1221 14.7235 17.387ZM15.3647 18.5348C15.8176 17.9839 16.0899 17.2794 16.0899 16.5123C16.0899 16.253 16.0899 15.4635 14.7151 12.9512C14.0611 11.7556 13.4178 10.7554 13.3907 10.7134C13.2833 10.5467 13.0985 10.4458 12.9001 10.4458C12.7017 10.4458 12.5169 10.5467 12.4095 10.7134C12.3824 10.7554 11.7391 11.7556 11.085 12.9512C9.71029 15.4635 9.71029 16.253 9.71029 16.5123C9.71029 17.2794 9.98259 17.9841 10.4353 18.5348H7.6236V9.38865H18.1761V18.5348H15.3647ZM19.3434 18.5348V8.805C19.3434 8.48273 19.0822 8.2215 18.7598 8.2215H7.0401C6.71768 8.2215 6.45645 8.48273 6.45645 8.805V18.5348H5.39448V5.46527H20.4054V18.5348L19.3434 18.5348Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default FirePlaceIcon;
